// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiResultDefaultResponse {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiResultDefaultResponse.attributeTypeMap;
    }
}
MedicalV1MedicalBiResultDefaultResponse.discriminator = undefined;
MedicalV1MedicalBiResultDefaultResponse.additionalProperties = false;
MedicalV1MedicalBiResultDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "MedicalV1MedicalBiResultDefaultResponseData"
    },
];
//# sourceMappingURL=medicalV1MedicalBiResultDefaultResponse.js.map